import { PREFETCH_LOCALES } from '@/constant/prefetch-shared'

// LOCALES 的值来自中立常量文件（constant/prefetch-shared.ts），与预取 boot 脚本共享
// 单一事实源，避免两边语言列表漂移。从 '@/locales' 导出的口径不变（143 处 import 无需改动）。
export const LOCALES = PREFETCH_LOCALES

export type Locale = (typeof LOCALES)[number]

const localeSet = new Set<string>(LOCALES)

// 插值函数
export function interpolate(
  str: string,
  replacements: Record<string, string | number>
): string {
  return str.replace(/{{\s*(\w+)\s*}}/g, (_, varName) => {
    return String(replacements[varName]) ?? ''
  })
}

export const isLangSupported = (lang: string) => localeSet.has(lang)

// TODO: 此函数需要和 withLocaleServer 同步改动
export function withLocale(url: string, lang: string): string {
  // 非以 '/' 开头，或绝对路径 (http/https)，则直接返回
  if (!url.startsWith('/') || /^https?:\/\//.test(url)) {
    return url
  }
  // 切掉开头的 '/'，再按 '/' 分割，并过滤掉空字符串 (比如末尾空段)
  // 这样就能自动去除多余的末尾斜杠
  const parts = url.slice(1).split('/').filter(Boolean)
  // 如果第一个路径片段是一个已支持的语言，则将其移除
  if (parts.length > 0 && isLangSupported(parts[0])) {
    parts.shift()
  }
  // 如果目标语言不是 DEFAULT_LOCALE 并且是已支持的语言，则在开头插入目标语言
  if (lang !== 'en' && isLangSupported(lang)) {
    parts.unshift(lang)
  }
  // 如果处理后 parts 为空数组，说明是根路径，直接返回 '/'
  // 否则在前面加一个 '/' 进行拼装
  return '/' + parts.join('/')
}

// TODO: 此函数需要和 withoutLocaleServer （暂未实现）同步改动
export function withoutLocale(url: string): string {
  // 非以 '/' 开头，或绝对路径 (http/https)，则直接返回
  if (!url.startsWith('/') || /^https?:\/\//.test(url)) {
    return url
  }

  // 拆分出纯路径与 ?query / #hash，确保后续保留
  const match = url.match(/^([^?#]*)(.*)$/)
  const path = match?.[1] ?? url
  const tail = match?.[2] ?? ''

  // 切掉开头的 '/'，按 '/' 分割并过滤空片段，自动去除多余斜杠
  const parts = path.slice(1).split('/').filter(Boolean)

  // 如果第一个路径片段是一个已支持的语言，则将其移除
  if (parts.length > 0 && isLangSupported(parts[0])) {
    parts.shift()
  }

  // 组装回路径；若 parts 为空则返回根路径 '/'，并保留 query/hash
  return '/' + parts.join('/') + tail
}
